<style lang="scss" scoped>
  .align-center-objects {
    display: flex;
    align-items: center;
  }

  .fit-credit-card-icon {
    flex: 0 0 5%;
    max-width: 5%;
  }

  .fit-inputs {
    flex: 0 0 95%;
    max-width: 95%;
  }

  .change-credit-card-link {
    margin-left: 10px;
    color: #857a98;
    font-size: 10px;
    letter-spacing: -0.15px;
    line-height: 20px;
  }

  @media (max-width: 1499px) {
    .btn {
      font-size: 11px;
    }
  }

  #card-number {
    max-width: 180px;
  }

  .card-data {
    max-width: 100px;
  }
</style>

<template>
  <div class="row">
    <div class="col-1 px-0 align-center-objects fit-credit-card-icon">
      <IconCreditCard :size="23" />
    </div>
    <div class="col-11 px-0 fit-inputs">
      <div v-if="!changingCard">
        **** **** **** {{ lastFour }}<a
          class="change-credit-card-link"
          href="javascript:;"
          @click="changingCard=true;"
        >
          <u>{{ __('Alterar cartão') }}</u></a>
      </div>
      <div
        class="row"
        v-else
      >
        <div class="col-9 d-inline-flex">
          <Cleave
            class="form-control mr-10px"
            id="card-number"
            v-model="credit_card.number"
            type="text"
            :options="cleave.creditCard.options"
            placeholder="Número do cartão"
            autocomplete="off"
          />
          <Cleave
            class="form-control card-data mr-10px"
            v-model="credit_card.validation"
            type="text"
            :options="cleave.validation.options"
            placeholder="Validade"
            autocomplete="off"
          />
          <input
            class="form-control card-data"
            v-model="credit_card.security_code"
            type="number"
            placeholder="Código"
            autocomplete="off"
          >
        </div>
        <div class="col-3 px-0">
          <button
            class="btn btn-primary"
            @click="confirmCreditCardChange"
          >
            {{ __('Trocar Cartão') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cleave from 'vue-cleave-component';
import Swal from 'sweetalert2';

export default {
  components: {
    Cleave,
  },

  props: {
    card_last_four: {
      type: String,
      required: false,
    },
    account_name: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      changingCard: false,
      lastFour: this.card_last_four,
      credit_card: {
        number: '',
        validation: '',
        security_code: '',
      },
      cleave: {
        creditCard: {
          options: {
            numericOnly: true,
            creditCard: true,
            delimiter: '.',
          },
        },
        validation: {
          options: {
            date: true,
            datePattern: ['m', 'y'],
          },
        },
      },
    };
  },

  computed: {
    years () {
      const year = new Date().getYear();
      return Array.from({ length: 10 }, (value, index) => (year + index).toString().substr(-2));
    },
  },

  methods: {
    confirmCreditCardChange () {
      Swal.fire({
        icon: 'question',
        title: this.__('Você tem certeza que quer alterar seu cartão de crédito?'),
        width: 350,
        buttonsStyling: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: this.__('Trocar Cartão'),
        cancelButtonColor: 'transparent',
        cancelButtonText: this.__('Cancelar'),
        showCancelButton: true,
        customClass: {
          container: 'container-swal2',
          confirmButton: 'btn btn-primary ',
          cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
        },
      }).then((result) => {
        if (result.dismiss !== 'cancel') {
          this.creditCardToken();
        }
      });
    },
    creditCardToken () {
      Iugu.setAccountID('4A91EA36FFCD4142947ECF5BA0352C52'); // TODO get from config
      Iugu.setup();

      const names = this.account_name.split(' ');

      const cc = Iugu.CreditCard(
        this.credit_card.number,
        this.credit_card.validation.substr(0, 2),
        this.credit_card.validation.substr(2, 2),
        names[0],
        names[1],
        this.credit_card.security_code,
      );

      const paymentForm = new BulldeskForm({
        payment: {
          token: '',
        },
      });

      const tokenResponseHandler = (data) => {
        if (data.errors) {
          alert(`Erro salvando cartão: ${JSON.stringify(data.errors)}`);
        } else {
          paymentForm.payment.token = data.id;

          Http.put('/billing/card', paymentForm)
            .then((data) => {
              console.log(data);
              Alert.success(this.__('Cartão de crédito alterado com sucesso!'));
              this.changingCard = false;
              const numbers = this.credit_card.number;
              this.lastFour = numbers.substr((numbers.length - 5), 4);
            })
            .catch((data, a) => {
              const error = data[Object.keys(data)]
                    || 'Ops, não foi possível concluir sua compra.';

              Alert.error(error);
            });
        }
      };

      Iugu.createPaymentToken(cc, tokenResponseHandler);
      return false;
    },
  },
};
</script>
